import { OrgBaseInterface } from "../Shared/OrgBase.Interace";
import { LocationVarKey } from "../Variables/Generated/LocationVarKey.Data";

// LINK - libs/entities/src/App/App.Entity.ts
export enum AppType {
  HUBSPOT = "hubspot",
  SLACK = "slack",
  TWILIO = "twilio",
  MANDRILL = "mandrill",
  FACEBOOK_MESSENGER = "facebook-messenger",
  // TRANSCRIPT = 'transcript',
  // SITELINK = 'siteLink',
  // TENANT = 'tenant',
  // SSM = 'ssm',
  // SSMREST = 'ssmRest',
  // STOREEDGE = 'storEdge',
  GOOGLE = "google",
  WHATSAPP = "whatsapp",
}

export interface AppInterface extends OrgBaseInterface {
  name: string;
  type: AppType;
  active: boolean;
  identifier?: string;
  data?: any;
  token?: any;
}

export const LocationVarKeyForAppType: { [appType in AppType]: LocationVarKey } = {
  [AppType.HUBSPOT]: LocationVarKey.HubspotAppId,
  [AppType.SLACK]: LocationVarKey.SlackAppId,
  [AppType.TWILIO]: LocationVarKey.TwilioAppId,
  [AppType.MANDRILL]: LocationVarKey.MandrillAppId,
  [AppType.FACEBOOK_MESSENGER]: LocationVarKey.FacebookMessengerAppId,
  [AppType.GOOGLE]: LocationVarKey.GoogleAppId,
  [AppType.WHATSAPP]: LocationVarKey.WhatsAppAppId,
};
